import React, { useState, useRef, useEffect, use } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../store";
import { getSellingSourceList, scanProduct, sellStock, uploadInvoice } from "../publicationSlice";
import { length_Thirteen, validateIsFileImageType, image_size_5MB } from "../../../Utils/validators";
import moment from "moment";
import barCode from "../../../Assets/Images/icons/barcode.png";
import DeleteIcon from "@mui/icons-material/Delete";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import DateTimePicker from "../../../Component/dateTimePicker";
import { useDebounce } from "../../../Hooks/useDebounce";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { stockSellingType, stockShiftingType, stockShiftType } from "../../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const SellStock = () => {
  const [shiftType, setShiftType] = useState<any>(""); // Define shiftType in state
  const dispatch: Function = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement>(null);
  const updateState = (key: any) => {
    setState((prev: any) => ({ ...prev, ...key }));
  };
  const { Name } = useSelector((state: any) => ({
    Name: state?.homeReducer?.Name,
  }));
  const [mediaFiles, setMediaFiles] = useState<any>();

  const initialStock = {
    _id: "",
    name: "",
    price: 0,
    coverImage: "",
    quantity: "",
    newQuantity: 1,
    uniqueNo: "",
  };
  const [state, setState] = useState<any>({
    barcode: "",
    newStockData: {
      product: [initialStock],
      totalQty: 0,
      totalAmount: 0,
    },
    invoiceNo: "",
    entryDate: moment
      .utc(new Date())
      .utcOffset(330)
      .format("YYYY-MM-DD HH:mm:ss"),
    totalAmount: 0,
    invoiceLink: "",
    selectedInvoice: "",
    sellingSrcName: "",
    sellingSource: [],
    shiftingFrom: "twobrothers-inhouse",
    quantityTotal: 0,
  });
  useEffect(() => {
    dispatch(
      getSellingSourceList({
        callback: (res: any) => {
          updateState({ sellingSource: res?.data });
        },
        errorCallback: () => { },
      })
    )
  }, []);

  const debouncedValue = useDebounce(state?.barcode, 300);
  useEffect(() => {
    if (debouncedValue && debouncedValue?.length > 12) {
      const existingStock = state?.newStockData?.product?.find(
        (item: any) => item?.uniqueNo === debouncedValue
      );
      if (existingStock) {
        // dispatch(showErrorSnackbar("Stock already exists"));
        setState((prevState: any) => ({
          ...prevState,
          barcode: "",
        }));
      } else {
        dispatch(
          scanProduct({
            id: debouncedValue,
            callback: (res: any) => {
              if (res?.data) {
                let newStockData = [...(state?.newStockData?.product || [])];
                let totalQty = state?.quantityTotal || 0;
                let totalAmount = state?.totalAmount || 0;
                const selectedSellingSrc = res?.data?.sourcePrice.find(
                  (src: any) => src?.sourceName === state?.sellingSrcName?.name
                );
                const productPrice = res?.data?.offerPrice || 0;
                const filterShift =
                  res?.data?.stock?.find(
                    (itm: any) => itm?.location === state?.shiftingFrom
                  ) || 0;
                const qty = filterShift?.quantity > 0 ? 1 : 0
                const productData = {
                  _id: res?.data?._id,
                  coverImage: res?.data?.image,
                  uniqueNo: res?.data?.uniqueNo,
                  name: res?.data?.name.toUpperCase(),
                  price:
                    state?.shiftingTo === "twobrothers-inhouse" ||
                      state?.shiftingTo === "publication-inhouse"
                      ? productPrice
                      : selectedSellingSrc?.price,
                  quantity: filterShift?.quantity || "0",
                  newQuantity: qty,
                };
                totalQty += qty;
                updateState({ quantityTotal: totalQty });
                newStockData.push(productData);
                if (selectedSellingSrc) {
                  if (totalAmount !== 0) {
                    totalAmount += selectedSellingSrc.price;
                  } else {
                    totalAmount = selectedSellingSrc.price;
                  }
                  updateState({ totalAmount });
                } else if (state?.shiftingTo === "twoBrothers-inhouse") {
                  totalAmount += res?.price || 0;
                  updateState({ totalAmount });
                } else {
                  const price = selectedSellingSrc?.price || 0;
                  totalAmount += price;
                  updateState({ totalAmount });
                }
                const productArr = {
                  product: newStockData,
                  totalQty,
                  totalAmount,
                };
                updateState({
                  newStockData: productArr,
                  quantityTotal: totalQty,
                  barcode: "",
                });
              } else {
                dispatch(showSnackbar({ message: "No product found with this number", type: "error" }));
                setTimeout(() => {
                  dispatch(hideSnackbar());
                }, 5000);
              }
            },
            errorCallback: () => { },
          })
        );
      }
    }
    focusBarcodeInput();

  }, [debouncedValue]);

  const handleChangeInvoice = (e: any) => {
    e.preventDefault();
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!mediaTypes.includes(file.type)) {
      console.error("Unsupported file type:", file.type);
      return;
    }
    reader.onloadend = () => {
      setMediaFiles(file);
      setState((prevState: any) => ({
        ...prevState,
        selectedInvoice: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const onChange = (num: any) => {
    const obj = {
      barcode: "",
      newStockData: {
        product: [initialStock],
        totalQty: 0,
        totalAmount: 0,
        isCombo: false,
      },
      invoiceNo: "",
      totalAmount: 0,
      entryDate: moment
        .utc(new Date())
        .utcOffset(330)
        .format("YYYY-MM-DD HH:mm:ss"),
      invoiceLink: "",
      selectedInvoice: "",
      shiftingFrom: num,
    };
    updateState(obj);
  };


  const onChangeDropdown = (val: any) => {
    if (val) {
      updateState({
        sellingSrcName: val,
        barCode: "",
        newStockData: {
          product: [initialStock],
          totalQty: 0,
          totalAmount: 0,
        },
        invoiceNo: "",
        entryDate: moment
          .utc(new Date())
          .utcOffset(330)
          .format("YYYY-MM-DD HH:mm:ss"),
        totalAmount: 0,
        invoiceLink: "",
        selectedInvoice: "",
      });
    }
  };

  const handleChangeBarcode = (e: any) => {
    setState((prevState: any) => ({
      ...prevState,
      barcode: e.target.value.toUpperCase(),
    }));
  };
  const handleChange = (e: any, item: any, index: any) => {
    const { newStockData } = state;
    e.preventDefault();
    const newArr = JSON.parse(JSON.stringify(newStockData?.product));
    let inputValue = e.target.value;
    if (Number(inputValue) <= Number(item?.quantity)) {
      newArr[index].newQuantity = inputValue !== "" ? Number(inputValue) : "";
      const productPrice = newArr?.reduce((acc: any, curr: any) => {
        return acc + curr?.price * (curr?.newQuantity);
      }, 0);
      const totalQuantity = newArr
        .filter((itm: any) => itm?._id !== "")
        .reduce((acc: any, curr: any) => {
          return acc + curr?.newQuantity;
        }, 0);
      updateState({
        newStockData: {
          totalQty: totalQuantity,
          product: newArr,
          totalAmount: productPrice,
        },
        totalAmount: productPrice,
        quantityTotal: totalQuantity,
      });
    } else {
      dispatch(showSnackbar({ message: "Quantity is not more than stock quantity", type: "error" }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    }
  };
  const handleDelete = (index: number) => {
    const newArr = [...state?.newStockData?.product];
    if (index > -1) {
      newArr.splice(index, 1);
    }
    setState((prevState: any) => ({
      ...prevState,
      newStockData: {
        ...prevState.newStockData,
        product: newArr,
      },
    }));
    const productPrice = newArr.reduce((acc, curr) => {
      return acc + (curr?.price || 0) * (curr?.newQuantity || 0);
    }, 0);
    const totalQuantity = newArr
      .filter((item) => item?._id !== "")
      .reduce((acc, curr) => acc + (curr?.newQuantity || 0), 0);
    setState((prevState: any) => ({
      ...prevState,
      newStockData: {
        ...prevState.newStockData,
        product: newArr,
        totalAmount: productPrice,
        totalQty: totalQuantity,
      },
      totalAmount: productPrice,
      quantityTotal: totalQuantity,
    }));
  };

  const focusBarcodeInput = (e?: any) => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handelClick = () => {
    focusBarcodeInput();
  };
  useEffect(() => {
    if (state?.sellingSrcName) {
      focusBarcodeInput();
    }
  }, [state?.sellingSrcName]);
  const handleClose = () => {
    updateState({ barcode: "" });
  };
  const onSellStock = (invoiceLink: any) => {
    if (invoiceLink) {
      const {
        entryDate,
        invoiceNo,
        totalAmount,
        newStockData,
        quantityTotal,
      } = state;
      const ProductArr = newStockData?.product
        ?.filter((item: any) => item?._id !== "")
        ?.map((item: any) => {
          return {
            productId: item?._id,
            quantity: Number(item?.newQuantity),
          };
        });
      const reqBody = {
        from: state?.shiftingFrom,
        sourceId: state?.sellingSrcName?._id,
        status: 3,
        invoiceNo,
        file: invoiceLink,
        totalCount: quantityTotal,
        totalAmount: Number(totalAmount),
        addedDate: entryDate,
        products: ProductArr,
      };

      const clearState = {
        barcode: "",
        newStockData: {
          product: [initialStock],
          totalQty: 0,
          totalAmount: 0,
        },
        invoiceNo: "",
        entryDate: moment
          .utc(new Date())
          .utcOffset(330)
          .format("YYYY-MM-DD HH:mm:ss"),
        totalAmount: 0,
        invoiceLink: "",
        selectedInvoice: "",
        sellingSrcName: "",
        quantityTotal: 0,
        from: state?.shiftingFrom,
      };
      dispatch(
        sellStock({
          params: reqBody,
          callback: (res: any) => {
            if (res?.status === "success") {
              updateState(clearState);
              dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
              setTimeout(() => {
                dispatch(hideSnackbar());
              }, 5000);
            }
          },
          errorCallback: (error: any) => {
            console.error(error);
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          },
        })
      );
    }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (mediaFiles) {
      dispatch(
        uploadInvoice({
          params: mediaFiles,
          callback: (res: any) => {
            if (res?.status === "success") {
              onSellStock(res?.data?.name)
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          },
        })
      );
    } else {
      dispatch(showSnackbar({ message: "Please upload invoice", type: "error" }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    };
  };
  const validationArr = () => {
    let disable = false;
    state?.newStockData?.product?.forEach((itm: any) => {
      if (itm?.newQuantity <= 0 || itm?.price === undefined) {
        disable = true;
      }
    });
    return disable;
  };
  const validationStockQuantity = () => {
    let disable = false;
    if (
      state?.newStockData?.product?.length > 0
    ) {
      let filterQty = state?.newStockData?.product?.filter(
        (subItem: any) => subItem?.stockQuantity === 0
      );
      if (filterQty?.length > 0) {
        disable = true;
      }
    }
    return disable;
  };
  const validations = () => {
    const { invoiceNo, totalAmount } = state;
    return (
      invoiceNo === "" ||
      totalAmount === 0 ||
      mediaFiles === undefined ||
      mediaFiles === "" ||
      validationStockQuantity() ||
      validationArr()
    );
  };
  const renderTable = () => {
    return (
      <div className="admin-table table-responsive">
        <table className="table table-striped table-hover align-middle text-md-start text-center">
          <thead>
            <tr>
              <th>Product Image</th>
              <th>Product Name</th>
              <th>Product Price</th>
              <th>Available Stocks</th>
              <th>Selling Stocks</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {state?.newStockData?.product?.map((item: any, index: any) => {
              if (item?._id) {
                return (
                  <>
                    <tr key={item?._id}>
                      <td>
                        <img
                          src={item?.coverImage}
                          alt="coverImage"
                          style={{ height: "50px", width: "60px" }}
                        />
                        {item?.price === undefined && (<span className="text-danger d-block fw-bold">Please Remove The {item?.name} its Price is 0 </span>)}
                      </td>
                      <td className="col-md-3">{item?.name}</td>
                      <td>
                        <InputField
                          placeholder={"₹"}
                          disabled
                          value={item?.price !== undefined ? item?.price : 0}
                        />
                      </td>
                      <td>
                        <InputField
                          placeholder={"₹"}
                          disabled
                          value={item?.quantity}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter quantity"
                          onChange={(e) => handleChange(e, item, index)}
                          value={item.newQuantity}
                        />
                      </td>
                      <td>
                        <ClearOutlinedIcon
                          className="colorPurple cursor"
                          fontSize="small"
                          onClick={() => {
                            handleDelete(index);
                          }}
                        />
                      </td>
                    </tr>
                  </>
                );
              } else {
                return (
                  <tr className="d-flex my-3">
                    <input
                      type="text"
                      className="form-control w-50"
                      ref={inputRef}
                      value={state?.barcode}
                      placeholder=""
                      maxLength={length_Thirteen - 1}
                      onChange={handleChangeBarcode}
                      disabled={
                        !state?.sellingSrcName &&
                          (state?.shiftingFrom === "twobrothers-inhouse" ||
                            state?.shiftingFrom === "twobrothers-warehouse" ||
                            state?.shiftingFrom === "publication-inhouse" ||
                            state?.shiftingFrom === "publication-warehouse")
                          ? true
                          : false
                      }
                    />
                    <span className="text-dark d-flex">
                      <DeleteIcon
                        className="cursor"
                        color="error"
                        fontSize="small"
                        onClick={() => handleClose()}
                      />
                    </span>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  };
  const renderForm = () => {
    return (
      <form onSubmit={handleSubmit} >
        <div className="row">
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Date"} />
            <DateTimePicker
              value={state?.entryDate}
              setInputText={(value: any) => {
                updateState({ entryDate: value });
              }}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Invoice No:"} />
            <InputField
              placeholder="Invoice No:"
              value={state?.invoiceNo}
              setInputText={(val: any) => updateState({ invoiceNo: val })}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Stock Out By:"} />
            <InputField
              placeholder="Stock Out By:"
              value={"Publication"}
              disabled={true}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Total Amount"} />
            <InputField
              placeholder="Total Amount"
              value={state?.totalAmount}
              disabled={true}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Invoice Image"} />
            <ImagePickerAndViewer
              value={state?.selectedInvoice}
              handleChange={(e: any) => handleChangeInvoice(e)}
              htmlFor={"pdf-upload-1"}
              doctype={"pdf/image"} />
          </div>
        </div>
        <div className="col-md-2 mx-auto my-4">
          <Submitbtn
            name={"Save and Update Stock"}
            disabled={validations()}
          />
        </div>
      </form >
    )
  }

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Sell Stock"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4">
          <div className="row">
            <div className="col-lg-8 mb-3">
              <LabelInput labelName={"Shifting From"} />
              {stockSellingType?.map((item) => (
                <span className="me-2 mx-2">
                  <input
                    type="radio"
                    value={state?.shiftingFrom}
                    checked={state?.shiftingFrom === item?.value}
                    onChange={() => onChange(item?.value)}
                    className="me-2"

                  />
                  {item?.name}
                </span>
              ))}
            </div>
            <div className="col-lg-3 mb-3">
              <LabelInput labelName={"Selling Source"} />
              <DropdownWithClear
                labelName={"Selling Source "}
                setInputText={(val: any) => onChangeDropdown(val)}
                value={state?.sellingSrcName}
                options={state?.sellingSource}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <LabelInput labelName={"Scan QR Code"} />
          <div className="bxshadow p-2 borderRadius text-center cursor col-3" onClick={handelClick}>
            <img src={barCode} alt="QR Code" width={30} />
          </div>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderTable()}
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderForm()}
        </div>
      </div>
    </div>
  );
};

export default SellStock;
